/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import {
  Linking, Platform, Text, View,
} from 'react-native';
import RocketIcon from '../components/RocketIcon';
import PressableStyled from '../components/PressableStyled';
import Colors from '../constants/Colors';
import { logEvent } from '../components/LogEvent';

export default function UpdateAppScreen() {
  const [loading, setLoading] = useState(false);

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <RocketIcon />
        <Text style={{
          fontSize: 22,
          lineHeight: 33,
          fontFamily: 'Poppins_600SemiBold',
          color: Colors.light.hereworksBlack600,
          textAlign: 'center',
          marginTop: 16,
        }}>New update available</Text>
        <Text style={{
          fontSize: 16,
          lineHeight: 24,
          fontFamily: 'Roboto_400Regular',
          color: Colors.light.hereworksBlack400,
          textAlign: 'center',
          marginTop: 4,
        }}>Please update application to the latest version</Text>
      </View>
      <PressableStyled
        onPress={() => {
          logEvent('UpdateAppScreen', 'update_button');
          if (Platform.OS === 'ios') Linking.openURL('https://apps.apple.com/ie/app/hereworks-insights/id1634396991');
          else Linking.openURL('https://play.google.com/store/apps/details?id=hereworks.apk');
        }}
        style={{
          backgroundColor: Colors.light.hereworksBlue500,
          margin: 24,
          marginBottom: 32,
          alignSelf: 'stretch',
          alignItems: 'center',
          borderRadius: 4,
        }}>
        <Text style={{
          padding: 8,
          color: '#fff',
          fontFamily: 'Roboto_400Regular',
          fontSize: 16,
          lineHeight: 24,
        }}>Update</Text>
      </PressableStyled>
    </View>
  );
}
